import i18n from '../../i18n';

/** Cached once — does not change at runtime (CRA). */
export const ENVIRONMENT: string = process.env.NODE_ENV ?? 'unknown';

/** Active UI language from i18n (i18n also keeps `<html lang>` in sync — see i18n.ts). */
export function getLanguage(): string | undefined {
    return i18n.resolvedLanguage || i18n.language || undefined;
}

export function buildSafePageLocation(safePath: string): string | undefined {
    if (typeof window === 'undefined') {
        return undefined;
    }
    return `${window.location.origin}${safePath}`;
}
